import type { ReactNode } from "react";

export function PrivacyPolicy() {
  return (
    <div style={{
      maxWidth: "720px", margin: "0 auto", padding: "48px 24px",
      color: "var(--color-text-primary)", lineHeight: 1.7,
    }}>
      <h1 style={{ fontSize: "24px", fontWeight: 700, marginBottom: "8px" }}>Privacy Policy</h1>
      <p style={{ color: "var(--color-text-muted)", fontSize: "13px", marginBottom: "32px" }}>
        Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
      </p>

      <Section title="What we collect">
        <p>We collect the information you provide when you create an account (email address) and the task data you create in Stride (tasks, projects, notes, and calendar events).</p>
        <p>When you connect a calendar, we store OAuth tokens to fetch your calendar events. We access your calendar in read-only mode.</p>
      </Section>

      <Section title="How we use your data">
        <p>Your data is used solely to provide the Stride service. We do not sell, rent, or share your personal information with third parties for marketing purposes.</p>
      </Section>

      <Section title="Third-party services">
        <ul style={{ paddingLeft: "20px" }}>
          <li><strong>Supabase</strong> — database and authentication hosting</li>
          <li><strong>Google</strong> — calendar integration (when you connect Google Calendar)</li>
          <li><strong>Microsoft</strong> — calendar integration (when you connect Outlook/Exchange)</li>
          <li><strong>Stripe</strong> — payment processing</li>
          <li><strong>Sentry</strong> — error monitoring</li>
        </ul>
      </Section>

      <Section title="Data retention">
        <p>Your data is retained as long as your account is active. You can export or delete all your data at any time from Settings.</p>
      </Section>

      <Section title="Contact">
        <p>Questions? Reach out at the email address on our website.</p>
      </Section>
    </div>
  );
}

function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div style={{ marginBottom: "28px" }}>
      <h2 style={{ fontSize: "16px", fontWeight: 600, marginBottom: "12px" }}>{title}</h2>
      <div style={{ color: "var(--color-text-secondary, var(--color-text-muted))", fontSize: "14px" }}>{children}</div>
    </div>
  );
}
